import { type PropsWithChildren } from "react";
import { CacheProvider as CacheProviderBase } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "@mui/stylis-plugin-rtl";

import { getDir } from "../hooks/useLocaleInfo";
import type { Locale } from "../utils/locale";

const caches = {
  ltr: createCache({
    key: "muicache-ltr",
    stylisPlugins: [prefixer],
  }),
  rtl: createCache({
    key: "muicache-rtl",
    stylisPlugins: [prefixer, rtlPlugin],
  }),
};

type Props = PropsWithChildren<{
  locale: Locale;
}>;

export function CacheProvider({ locale, children }: Props) {
  return (
    <CacheProviderBase value={caches[getDir(locale)]}>
      {children}
    </CacheProviderBase>
  );
}
